module.exports = __webpack_public_path__ + "img/silent-night.5e4ca8ea.jpeg";